import { apiUrl, apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  selectedBranch: [],
  branches: [],
  corporateBranch: null,
  titleCenterBranch: null,
}

const OKC_BRANCH_ID = 3

const createBranchSlice = (set, get) => ({
  ...initialState,
  fetchBranches: async () => {
    try {
      const response = await fetch(
        `${apiUrlV2}/branches`,
        { headers: get().requestHeaders}
      )
      const data = await response.json()
      set((state) => ({ branches: data.data }))
    } catch (err) {
      get().logError('There was an error fetching branches.', err)
    }
  },
  setSelectedBranch: (branch) => {
    set((state) => ({ selectedBranch: branch }))
  },
  fetchTitleCenterBranch: async () => {
    try {
      const response = await fetch(
        `${apiUrl}/branches/${OKC_BRANCH_ID}?no_includes=true`,
        { headers: get().requestHeaders}
      )
      const data = await response.json()
      set((state) => ({ titleCenterBranch: data.data }))
    } catch (err) {
      get().logError('There was an error fetching branch information.', err)
    }
  },
  fetchCorporateBranch: async () => {
    try {
      const response = await fetch(
        `${apiUrl}/branches/?no_includes=true&filter[scope]=corporate`,
        { headers: get().requestHeaders}
      )
      const data = await response.json()
      set((state) => ({ corporateBranch: data.data[0] }))
    } catch (err) {
      get().logError('There was an error fetching branch information.', err)
    }
  },
  resetBranchSlice: () => set(initialState)
})

export default createBranchSlice